import schedule from '../components/schedule/schedule'

export default {
  schedule
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/components.js